import React from "react";
import stl from "./rxConfirm.module.scss";
import { FmButton, FmDrawer } from "@/ui-component";
import { usePrescriptionContext } from "@/src/provider";
import { useTranslation } from "@/src/i18n/client";
import classnames from "classnames";

interface Props {
    onClose: () => void;
    Edit: () => void;
    Confirm: () => void;
    visible: boolean;
}

const RxConfirm: React.FC<Props> = (props) => {
    const { t } = useTranslation("rx");
    const { onClose, visible, Edit, Confirm } = props;
    const [activeData] = usePrescriptionContext((state) => [state.activeData]);
    return (
        <FmDrawer
            className={classnames(stl["ufmeuirxconfirm"], "ufmeuirxconfirm")}
            open={visible}
            closeable
            onClose={onClose}
            headerChildren
            anchor="bottom"
            closeablePosition="right"
            footerClassName={stl["footer-container"]}
            footer={
                <>
                    <FmButton
                        variant="outlined"
                        size="large"
                        onClick={Edit}
                        fullWidth
                    >
                        {t("rx:rxConfirmAlert.Edit")}
                    </FmButton>
                    <FmButton
                        style={{ marginTop: "0.2rem" }}
                        onClick={Confirm}
                        size="large"
                        fullWidth
                    >
                        {t("rx:rxConfirmAlert.Confirm")}
                    </FmButton>
                </>
            }
            childrenClassName={stl["rx-confirm-dialog-container"]}
        >
            <div className={stl["m-rx-confirm"]}>
                <p className={stl["title"]}>
                    {t("rx:rxConfirmAlert.checkInfo")}
                </p>
                <div className={stl["rx-confirm-container"]}>
                    <p className={stl["rx-line"]}>
                        <span>{t("rx:rxConfirmAlert.PD")}</span>
                        {activeData.prescription.left_pd ? (
                            <span>
                                {" "}
                                <span>
                                    {t("rx:rxConfirmAlert.Rigth")}{" "}
                                    {activeData.prescription.right_pd}
                                </span>{" "}
                                <span>
                                    {t("rx:rxConfirmAlert.Left")}{" "}
                                    {activeData.prescription.left_pd}
                                </span>{" "}
                            </span>
                        ) : (
                            <span>{activeData.prescription.pd}</span>
                        )}
                    </p>
                    <div className={stl["rx-vlaues"]}>
                        <div className={stl["line"]}>
                            <p>{t("rx:rxConfirmAlert.ODRight")}</p>
                            <p>
                                <span>{t("rx:rxConfirmAlert.SPH")} </span>
                                {activeData.prescription.od_sph
                                    ? parseFloat(
                                          activeData.prescription.od_sph.toString(),
                                      ) > 0
                                        ? "+" +
                                          parseFloat(
                                              activeData.prescription.od_sph.toString(),
                                          ).toFixed(2)
                                        : activeData.prescription.od_sph
                                    : "+0.00"}
                            </p>
                            <p>
                                <span>{t("rx:rxConfirmAlert.CYL")} </span>
                                {activeData.prescription.od_cyl
                                    ? parseFloat(
                                          activeData.prescription.od_cyl.toString(),
                                      ) > 0
                                        ? "+" +
                                          parseFloat(
                                              activeData.prescription.od_cyl.toString(),
                                          ).toFixed(2)
                                        : activeData.prescription.od_cyl
                                    : "+0.00"}
                            </p>
                            <p>
                                <span>{t("rx:rxConfirmAlert.Axis")}</span>{" "}
                                {activeData.prescription.od_axis
                                    ? activeData.prescription.od_axis
                                    : "000"}
                            </p>
                        </div>
                        <div className={stl["line"]}>
                            <p>{t("rx:rxConfirmAlert.OSLeft")}</p>
                            <p>
                                <span>{t("rx:rxConfirmAlert.SPH")} </span>
                                {activeData.prescription.os_sph
                                    ? parseFloat(
                                          activeData.prescription.os_sph.toString(),
                                      ) > 0
                                        ? "+" +
                                          parseFloat(
                                              activeData.prescription.os_sph.toString(),
                                          ).toFixed(2)
                                        : activeData.prescription.os_sph
                                    : "+0.00"}
                            </p>
                            <p>
                                <span>{t("rx:rxConfirmAlert.CYL")}</span>
                                {activeData.prescription.os_cyl
                                    ? parseFloat(
                                          activeData.prescription.os_cyl.toString(),
                                      ) > 0
                                        ? "+" +
                                          parseFloat(
                                              activeData.prescription.os_cyl.toString(),
                                          ).toFixed(2)
                                        : activeData.prescription.os_cyl
                                    : "+0.00"}
                            </p>
                            <p>
                                <span>{t("rx:rxConfirmAlert.Axis")}</span>{" "}
                                {activeData.prescription.os_axis
                                    ? activeData.prescription.os_axis
                                    : "000"}
                            </p>
                        </div>
                    </div>
                    <p className={stl["rx-line"]}>
                        {t("rx:rxConfirmAlert.ADD")}{" "}
                        {activeData.prescription.add}
                    </p>
                </div>
            </div>
        </FmDrawer>
    );
};

export default RxConfirm;
